import { render, staticRenderFns } from "./AddProjectDeliverableList.vue?vue&type=template&id=c207c414&"
import script from "./AddProjectDeliverableList.vue?vue&type=script&lang=js&"
export * from "./AddProjectDeliverableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports